import { Component } from '@verndale/core';
import MicroModal from 'micromodal';

import { constEvent } from '../utils/constants';
import { dispatchGenericEvent } from '../utils/dispatch-events';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $el: this.el
    };
    this.modalId = null;
    this.genericModal = null;
    this.overlay = null;

    this.init();
  } //setupDefaults

  addListeners() {
    document?._on(
      constEvent.SHOW_ADD_TO_LIST_MODAL,
      this.loadAddToListView.bind(this)
    );

    document?._on(
      constEvent.ALLOW_OVERLAY_CLOSE_ADD_TO_LIST_MODAL,
      this.allowOverlayClose.bind(this, true)
    );
  } //addListeners

  init() {
    const { $el } = this.dom;

    this.genericModal = $el.closest('.generic-modal');
    if (this.genericModal) {
      this.modalId = this.genericModal.getAttribute('id') || null;
      this.overlay = this.genericModal._$('.generic-modal__overlay') || null;
    }
  } //init

  showModal() {
    if (this.modalId) {
      MicroModal.show(this.modalId, {
        closeTrigger: 'data-generic-modal-close',
        openClass: 'generic-modal--open',
        disableScroll: true,
        disableFocus: true,
        awaitOpenAnimation: true,
        awaitCloseAnimation: true,
        onShow: modal => this.allowOverlayClose(false),
        onClose: modal => this.allowOverlayClose(false)
      });
    }
  } //showModal

  loadAddToListView(e) {
    e?.preventDefault();
    const { $el } = this.dom;
    const { loggedIn, loginPromptMessage } = $el?.dataset || {};

    if (loggedIn === 'true') {
      const productId = e?.detail || null;
      this.showModal();
      dispatchGenericEvent(constEvent.LOAD_ADD_TO_LIST_VIEW, productId);
    } else {
      dispatchGenericEvent(constEvent.SHOW_MODAL_LOGIN, loginPromptMessage);
    }
  } //loadAddToListView

  allowOverlayClose(allow) {
    allow
      ? this.overlay.setAttribute('data-generic-modal-close', true)
      : this.overlay.removeAttribute('data-generic-modal-close');
  } //allowOverlayClose
}

export default Module;
